import objectFitImages from 'object-fit-images';
import baguetteBox from 'baguettebox.js';
require('webcomponentsjs/lite');
import Menu from './Modules/Menu';
import { isTouchDevice } from './Modules/Helper';
import addMenuEventListener from './Modules/Menu';
import ScrollTop from './Modules/ScrollTop';
import Slider from './Modules/Slider';

document.addEventListener('DOMContentLoaded', function() {
    objectFitImages();
    baguetteBox.run('.gallery');
    const scrollTop = new ScrollTop(document.querySelector('#to-top'));
    scrollTop.init();
    addMenuEventListener();

    if (isTouchDevice()) {
        document.body.classList.add('touch');
    } else {
        document.body.classList.add('no-touch');
    }
});

window.addEventListener('WebComponentsReady', function() {
    // At this point we are guaranteed that all required polyfills have loaded,
    // all HTML imports have loaded, and all defined custom elements have upgraded
    document.registerElement('cc-slider', Slider);
});



// WEBPACK FOOTER //
// ./wp-content/themes/template/js/src/theme.js